import Service from './Service.js';

class Load extends Service {
  init() {
    this.handler = () => {
      this.trigger(this.props);
    };

    window.addEventListener('load', this.handler);
    return this;
  }

  kill() {
    window.removeEventListener('load', this.handler);
    return this;
  }

  get props() {
    return {};
  }

}

var instance = null;
export default function useLoad() {
  if (!instance) {
    instance = new Load();
  }

  var add = instance.add.bind(instance);
  var remove = instance.remove.bind(instance);
  var has = instance.has.bind(instance);

  function props() {
    return instance.props;
  }

  return {
    add,
    remove,
    has,
    props
  };
}